const ENV = import.meta.env;

export const API_STAGE = ENV.VITE_API_STAGE;
export const LGT_SERVER_URL = ENV.VITE_LGT_SERVER_URL;
export const LGT_VERIFY_URL = ENV.VITE_LGT_VERIFY_URL;
export const GOOGLE_MAPS_API_KEY = ENV.VITE_GOOGLE_MAPS_API_KEY;
export const SENTRY_DNS = ENV.VITE_SENTRY_DNS;
export const PRIVACY_POLICY_URL = ENV.VITE_PRIVACY_POLICY_URL;
export const COOKIE_POLICY_URL = ENV.VITE_COOKIE_POLICY_URL;
export const WORKOS_LEGITIMATE_ORG_ID = ENV.VITE_WORKOS_LEGITIMATE_ORG_ID;
export const POSTHOG_KEY = ENV.VITE_POSTHOG_KEY;
export const POSTHOG_HOST = ENV.VITE_POSTHOG_HOST;

export const getEnvironmentName = () => {
  switch (API_STAGE) {
    case "production":
      return "Production";
    case "staging":
      return "Staging";
    case "development":
      return "Development";
  }
};
